module.exports = __webpack_public_path__ + "static/media/cart-drawer@2x.90d34775.png";